const conditions = {
  "nature": [
    { "name": "不限" },
    { "name": "外企", },
    { "name": "国企" },
    { "name": "民营企业" },
    { "name": "政府/非营利组织" }
  ],
  "industries": [
    ["", "不限"],
    [101, "互联网", "010"],
    [422, "金融", "020"],
    [479, "教育", "050"],
    [458, "咨询/财会/法律", "080"],
    [360, "房地产/建筑/物业", "030"],
    [22, "消费品/零售/贸易", "170"],
    [535, "电子/通信/硬件", "040"],
    [534, "医疗/健康/制药", "120"],
    [416, "工业/机械", "140"],
    [29, "广告/传媒", "070"],
    [451, "能源/化工/环保", "200"],
    [320, "汽车", "060"],
    [10, "旅游/酒店/餐饮", "130"],
    [447, "娱乐/运动", "230"],
    [4, "中介服务", "160"],
    [433, "政府/非营利", "240"],
    [444, "服务业", "180"],
    [363, "交通物流", "100"],
    [373, "农/林/牧/渔", "250"],
    [339, "生产制造", "190"],
    [67, "设计", "090"],
    [36, "其他", "260"]
  ],
  "degrees": [
    ["", "不限", ""],
    [6, "中专", "Senior High School"],
    [7, "高中", "High School"],
    [1, "大专", "Diploma"],
    [2, "本科", "Bachelor"],
    [3, "硕士", "Master"],
    [4, "博士", "Doctor"],
    [5, "MBA", "MBA"],
  ],
  "scales": [
    { "option": "不限" },
    { "option": "10人以下" },
    { "option": "10-50人" },
    { "option": "50-100人" },
    { "option": "100-500人" },
    { "option": "500人以上", }
],
  "salaries": [
    ["", "不限"],
    [",3000", "3k以下"],
    ["3000,5000", "3-5k"],
    ["5000,10000", "5-10k"],
    ["10000,15000", "10-15k"],
    ["15000,20000", "15-20k"],
    ["20000,30000", "20-30k"],
    ["30000,50000", "30-50k"],
    ["50000,", "50k以上"]
  ],
  "experiences": [
    ["", "不限"],
    [",0", "应届生"],
    ["0,1", "1年以内"],
    ["1,3", "1-3年"],
    ["3,5", "3-5年"],
    ["5,10", "5-10年"],
    ["10,", "10年以上"]
  ],
  "internshipMonths": [
    '1个月',
    '2个月',
    '3个月',
    '4个月',
    '5个月',
    '6个月及以上',
  ],
  "internshipDays": [
    1,2,3,4,5,6,7
  ]
}

export {
  conditions
}